export default class InvalidGradient extends Error {}
